import React, { Component } from "react";
import TaxVerificationContainer from "payrolldashboard/containers/TaxVerificationContainer";
import { withRouter } from "react-router";

class TaxVerificationsDemo extends Component {
  render() {
    return (
      <div className="transition-item detail-page clearfix">
        <TaxVerificationContainer
          redirectToChecklist={() => {
            this.props.history.replace("/payroll");
            this.props.clearPayrollActiveTab();
          }}
        />
      </div>
    );
  }
}

export default withRouter(TaxVerificationsDemo);
